import React from 'react';
import {
  InnerPageContainer,
  PageContainer,
  PageContentContainer,
} from './AuthenticatedPageLayout.styles';

export const AuthenticatedPageLayout = ({
  children,
  navbar,
}: {
  children: React.ReactNode;
  navbar?: React.ReactNode;
}) => {
  return (
    <PageContainer>
      {navbar}
      <PageContentContainer>
        <InnerPageContainer>{children}</InnerPageContainer>
      </PageContentContainer>
    </PageContainer>
  );
};
